import React from 'react';
import { useWizard } from 'react-use-wizard';
import classnames from 'classnames';
var Breadcrumbs = function(param) {
    var children = param.children;
    var activeStep = useWizard().activeStep;
    return /*#__PURE__*/ React.createElement("div", {
        className: "Breadcrumbs"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "BreadcrumbsGuide"
    }, activeStep > 0 && activeStep < children.length && /*#__PURE__*/ React.createElement("h6", {
        className: classnames('stepLabel', {
            isCurrentStep: activeStep
        })
    }, "".concat(activeStep + 1, ".").concat(children[activeStep].props.name)), activeStep + 1 < (children === null || children === void 0 ? void 0 : children.length) && /*#__PURE__*/ React.createElement("h6", {
        className: "stepLabel"
    }, "".concat(activeStep + 2, ".").concat(children[activeStep + 1].props.name))), /*#__PURE__*/ React.createElement("div", {
        className: "BreadcrumbsSteps"
    }, children));
};
export default Breadcrumbs;
